module.exports = "/_next/static/images/logo_for_matrix-03ad3aa3324e518305fa53a72b45fdc6.png";